import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../../@types/filter";
import { Paginated } from "../../../../../@types/paginated";
import { apisiseci } from "../../../../api";
import { useDefaultSearchParams } from "../../../../../hooks/useSearchParams";
import { AttendanceLocalDepartment } from "../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentQueue } from "../../../../../@types/attendance-local-department-queue";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
  setor?: AttendanceLocalDepartment["id"]
};

export function useAttendanceLocalDepartmentQueueList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<AttendanceLocalDepartmentQueue>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['attendance-local', 'department', 'queue', 'list', params],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<AttendanceLocalDepartmentQueue>>(
        "/cms/fila_horarios/",
        { headers: { Authorization: `Bearer ${token}` }, params }
      );
      return response.data;
    },
  });
}
